import React from 'react';
import { Card, Image, Icon, Dimmer } from 'semantic-ui-react';

const CALLUX = {
  name: 'Callux',
  color: 'pink',
  hashtag: '#TeamCallux',
  discussionName: 'Callux',
};

const CASPAR = {
  name: 'Caspar Lee',
  color: 'green',
  hashtag: '#TeamCaspar',
  discussionName: 'dicasp',
};

const OLI = {
  name: 'Oli White',
  color: 'yellow',
  hashtag: '#TeamOli',
  discussionName: 'TheOliWhiteTV',
};

const InfluencerCardGroup = ({ onClick, selectedInfluencer }) => (
  <Card.Group itemsPerRow={3} stackable>

    <Card color="pink" onClick={() => onClick(CALLUX)}>
      <Dimmer active={selectedInfluencer !== CALLUX} className="influencer" />
      <Card.Content textAlign="center">
        <Image
          src="https://scontent-lhr3-1.cdninstagram.com/vp/37645842370b8cb4f8c86a694ff4aaa7/5B3E6924/t51.2885-19/s150x150/13774367_320579658276322_23557049_a.jpg"
          shape="circular"
          size="small"
          centered
        />
      </Card.Content>
      <Card.Content textAlign="center">
        <Card.Header>
          Callux
        </Card.Header>
        <Card.Description>
          #TeamCallux
        </Card.Description>
      </Card.Content>
      <Card.Content extra textAlign="center">
        <p>
          <Icon name="youtube" color="red" />
          2m subscribers
        </p>
        <p>
          <Icon name="instagram" color="pink" />
          1m followers
        </p>
        <p>
          <Icon name="twitter" color="blue" />
          1m followers
        </p>
      </Card.Content>
    </Card>

    <Card color="yellow" onClick={() => onClick(OLI)}>
      <Dimmer active={selectedInfluencer !== OLI} className="influencer" />
      <Card.Content textAlign="center">
        <Image
          src="https://scontent-lhr3-1.cdninstagram.com/vp/32aac60fe81ad394f05e002a5f406516/5B590873/t51.2885-19/s150x150/28764564_156983381784712_9112756919377854464_n.jpg"
          shape="circular"
          size="small"
          centered
        />
      </Card.Content>
      <Card.Content textAlign="center">
        <Card.Header>
          Oli White
        </Card.Header>
        <Card.Description>
          #TeamOli
        </Card.Description>
      </Card.Content>
      <Card.Content extra textAlign="center">
        <p>
          <Icon name="youtube" color="red" />
          3m subscribers
        </p>
        <p>
          <Icon name="instagram" color="pink" />
          1.8m followers
        </p>
        <p>
          <Icon name="twitter" color="blue" />
          1m followers
        </p>
      </Card.Content>
    </Card>

    <Card color="green" onClick={() => onClick(CASPAR)}>
      <Dimmer active={selectedInfluencer !== CASPAR} className="influencer" />

      <Card.Content textAlign="center">

        <Image
          src="https://scontent-lhr3-1.cdninstagram.com/vp/c7619854bfc61b5bbea12e3372edb271/5B5185DD/t51.2885-19/s150x150/29093660_162169737831914_4317875689484189696_n.jpg"
          shape="circular"
          size="small"
          centered
        />

      </Card.Content>
      <Card.Content textAlign="center">
        <Card.Header>
              Caspar Lee
        </Card.Header>
        <Card.Description>
              #TeamCaspar
        </Card.Description>
      </Card.Content>
      <Card.Content extra textAlign="center">
        <p>
          <Icon name="youtube" color="red" />
              8m subscribers
        </p>
        <p>
          <Icon name="instagram" color="pink" />
              3.5m followers
        </p>
        <p>
          <Icon name="twitter" color="blue" />
              6m followers
        </p>

      </Card.Content>
    </Card>
  </Card.Group>
);

export default InfluencerCardGroup;



// WEBPACK FOOTER //
// ./src/components/influencer-card-group/index.js